<template>
    <div>
        <div class="">
            <div>
                <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                    WEB URL
                </label>
                <input type="text" class="form-control " @change="onChange($event)"  :value="url" />
            </div>
            <div class="mt-3">
                <a  class="btn btn-secondary w-100" @click="onGO()">Go</a>
            </div>
        </div>
        <div class=" mt-3">
            <div class="d-flex align-items-center justify-content-between">
                <label class="d-block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-0 text-left w-24 !mb-0 !text-2xs">
                    SCROLL  
                </label>
                <Switches theme="bootstrap" v-model="scroll" color="success" ></Switches>
            </div> 
        </div>
        <div class="mb-3 mt-3">
            <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left ">Scroll Speed</label>
            <div>
                <select class="form-control" @change="setScrollSpeed" :value="scrollSpeed">
                    <option value="10">Very Slow</option>
                    <option value="25">Slow</option>
                    <option value="50">Normal</option>
                    <option value="100">Fast</option>
                    <option value="200">Very Fast</option>
                </select>
            </div>
        </div> 
        <div class="mt-3">
            <div>
                <label class="block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-2 text-left">
                    STOP SCROLLING PHRASE
                </label>
                <input type="text" class="form-control " @change="changeScrollPhrase($event)"  :value="scrollPhrase" />
            </div>
        
        </div>
    </div>
</template>
<script>
import Switches from 'vue-switches';

export default {
    name: "WebPageSettings",
    components:{
        Switches,
     },
    data(){
        return{
            url:"",
            scroll:false,
            scrollSpeed:50,
            scrollPhrase:0
        }
    },
    computed:{
        getActiveCanvasObjProps(){
            return this.$store.getters.getActiveObjectprops
        },
    },
    watch:{
        getActiveCanvasObjProps :{
          handler(updatedValues) {
            
           
            this.url = updatedValues.url;
            this.scroll = updatedValues.isScroll;
            this.scrollSpeed = updatedValues.scrollSpeed;
            this.scrollPhrase = updatedValues.scrolltoPhrase;

            },
            deep: true,
            immediate: true
        },
        scroll(value){
             this.turnOnScroll(value)
        }
    },
    methods:{
        onChange(e){
            debugger // eslint-disable-line no-debugger
            let value = e.target.value;

            this.url = value;
        },
        onGO(){
            this.$store.dispatch("setCurrentObjectProperties" , { url: this.url });
        },
        turnOnScroll(value){
            this.$store.dispatch("setCurrentObjectProperties" , { isScroll: value });
        },
        changeScrollPhrase(e){
            let value = e.target.value;
            this.$store.dispatch("setCurrentObjectProperties" , { scrolltoPhrase: value });
        },
        setScrollSpeed(e){
            let value = e.target.value;
            this.$store.dispatch("setCurrentObjectProperties" , { scrollSpeed: value })
        }
    }

}
</script>